import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import img from '../assets/images/img-contact.png'

function Contact(props) {
    const [showSuccess, setShowSuccess] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const form = e.target;
        const formData = new FormData(form);

        try {
            const response = await fetch('https://formspree.io/f/xzdyqraq', {
                method: 'POST',
                body: formData,
                headers: {
                    'Accept': 'application/json'
                }
            });

            if (response.ok) {
                setShowSuccess(true);
                form.reset();
                setTimeout(() => {
                    setShowSuccess(false);
                }, 5000);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div>

        <section className="tf-page-title style-2">    
            <div className="tf-container">
                <div className="row">
                    <div className="col-md-12">

                        <ul className="breadcrumbs">
                            <li><Link to="/">Home</Link></li>
                            <li>Contact</li>
                        </ul>
                
                    </div>
                </div>
            </div>                    
        </section>
                
        <section className="tf-contact">
            <div className="tf-container">
                <div className="row ">
                    <div className="col-md-6">
                        <div className="image ani4">
                            <img src={img} alt="Binasea" />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="tf-heading style-3">
                            <h4 className="heading">Drop Up A Message</h4>
                            <p className="sub-heading">Fill up this form and the D.T Wallet team will contact you soon.</p>
                        </div>
                        <form onSubmit={handleSubmit} id="commentform" className="comment-form">
                            <fieldset className="name">
                                <input type="text" id="name" placeholder="Your Full Name" className="tb-my-input" name="name" tabIndex="2" aria-required="true" required="" />
                            </fieldset>    
                            <fieldset className="email">
                                <input type="email" id="email" placeholder="Your Email Address" className="tb-my-input" name="email" tabIndex="2" aria-required="true" required="" />
                            </fieldset>
                            <div className="form-select" id="subject">
                                <select name="subject" required>
                                    <option value="">Select subject</option>
                                    <option value="refund">Refund Issue</option>
                                    <option value="voucher">Voucher Not Received</option>
                                    <option value="payment">Payment Problem</option>
                                    <option value="account">Account Issue</option>
                                    <option value="other">Other Inquiry</option>
                                </select>
                                <i className="icon-fl-down"></i>
                            </div>
                            <fieldset className="message">
                                <textarea id="message" name="message" rows="4" placeholder="Message" tabIndex="4" aria-required="true" required="" />
                            </fieldset>
                            <div className="btn-submit">
                                <button 
                                    className="tf-button" 
                                    type="submit"
                                    disabled={isSubmitting}
                                    style={{
                                        background: isSubmitting ? '#ccc' : '#FFC107', 
                                        color: '#000', 
                                        border: 'none',
                                        transition: 'all 0.3s ease',
                                        cursor: isSubmitting ? 'not-allowed' : 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isSubmitting) {
                                            e.target.style.background = '#E6A800';
                                            e.target.style.transform = 'scale(1.05)';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isSubmitting) {
                                            e.target.style.background = '#FFC107';
                                            e.target.style.transform = 'scale(1)';
                                        }
                                    }}
                                >
                                    {isSubmitting ? 'Sending...' : 'Send Message'}
                                </button>
                            </div>
                        </form>
                        

                    
                        
                    </div>
                </div>
            </div>
        </section>

            {/* Success Popup */}
            {showSuccess && (
                <div 
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(0, 0, 0, 0.7)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                        animation: 'fadeIn 0.3s ease'
                    }}
                    onClick={() => setShowSuccess(false)}
                >
                    <div 
                        style={{
                            background: '#fff',
                            borderRadius: '16px',
                            padding: '40px',
                            maxWidth: '500px',
                            width: '90%',
                            textAlign: 'center',
                            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
                            animation: 'slideUp 0.3s ease'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div 
                            style={{
                                width: '80px',
                                height: '80px',
                                background: '#FFC107',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                margin: '0 auto 20px',
                                fontSize: '40px'
                            }}
                        >
                            ✓
                        </div>
                        <h3 style={{fontSize: '24px', fontWeight: '700', marginBottom: '15px', color: '#000'}}>
                            Message Sent Successfully!
                        </h3>
                        <p style={{fontSize: '16px', color: '#666', marginBottom: '25px', lineHeight: '1.6'}}>
                            Thank you for reaching out to us. You will receive support from our team within 2 hours.
                        </p>
                        <button 
                            onClick={() => setShowSuccess(false)}
                            style={{
                                background: '#FFC107',
                                color: '#000',
                                border: 'none',
                                padding: '12px 30px',
                                borderRadius: '8px',
                                fontSize: '16px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.background = '#E6A800';
                                e.target.style.transform = 'scale(1.05)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.background = '#FFC107';
                                e.target.style.transform = 'scale(1)';
                            }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
            
        </div>
    );
}

export default Contact;